import script from "./FooterJez.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterJez.vue?vue&type=script&setup=true&lang=js"

import "./FooterJez.vue?vue&type=style&index=0&id=df4652a6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df4652a6"]])

export default __exports__